// @ts-nocheck
// ============================================
// 模式选择对话框组件
// 功能：在用户选择文本后，提供智能模式建议
// ============================================

import React, { useState, useEffect } from 'react';
import './ModeSelectionDialog.css';

type ModeType = 'quick_scan' | 'normal' | 'send_to_canvas';

interface ModeSelectionDialogProps {
  show: boolean;
  selectedText: string;
  onSelect: (mode: ModeType) => void;
  onCancel: () => void;
  [key: string]: any;
}

const ModeSelectionDialog: React.FC<ModeSelectionDialogProps> = ({ show, selectedText, onSelect, onCancel }) => {
  const [suggestedMode, setSuggestedMode] = useState<ModeType>('quick_scan');

  useEffect(() => {
    if (show && selectedText) {
      analyzeSuggestedMode(selectedText);
    }
  }, [show, selectedText]);

  const analyzeSuggestedMode = (text: string) => {
    const textLower = text.toLowerCase();
    const textLength = text.length;

    const academicKeywords = [
      'abstract', 'introduction', 'method', 'result', 'conclusion',
      'experiment', 'algorithm', 'propose', 'novel', 'approach',
      '摘要', '引言', '方法', '实验', '结果', '结论', '算法', '提出'
    ];

    const hasAcademicKeyword = academicKeywords.some(keyword =>
      textLower.includes(keyword)
    );

    if (hasAcademicKeyword || textLength > 200) {
      setSuggestedMode('quick_scan');
      return;
    }

    if (textLength < 80) {
      setSuggestedMode('send_to_canvas');
      return;
    }

    setSuggestedMode('normal');
  };

  const handleModeSelect = (mode: ModeType) => {
    onSelect(mode);
  };

  if (!show) return null;

  return (
    <div className="mode-dialog-overlay" onClick={onCancel}>
      <div className="mode-dialog-content" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <div className="mode-dialog-header">
          <h3>选择阅读模式</h3>
          <button className="close-btn" onClick={onCancel}>&times;</button>
        </div>

        <div className="mode-dialog-body">
          <div className="text-preview">
            <p className="preview-label">选中内容预览：</p>
            <p className="preview-text">
              {selectedText.length > 100
                ? selectedText.substring(0, 100) + '...'
                : selectedText}
            </p>
          </div>

          <div className="mode-options">
            <button
              className={`mode-option ${suggestedMode === 'quick_scan' ? 'recommended' : ''}`}
              onClick={() => handleModeSelect('quick_scan')}
            >
              <div className="mode-icon">🔍</div>
              <div className="mode-info">
                <h4>快速浏览模式 {suggestedMode === 'quick_scan' && <span className="badge">推荐</span>}</h4>
                <p>AI主动分析：翻译、核心观点、关键术语</p>
                <p className="mode-hint">适合论文段落、技术文档</p>
              </div>
            </button>

            <button
              className={`mode-option ${suggestedMode === 'normal' ? 'recommended' : ''}`}
              onClick={() => handleModeSelect('normal')}
            >
              <div className="mode-icon">💬</div>
              <div className="mode-info">
                <h4>问答模式 {suggestedMode === 'normal' && <span className="badge">推荐</span>}</h4>
                <p>对选中内容提问，AI回答</p>
                <p className="mode-hint">适合针对性问题</p>
              </div>
            </button>

            <button
              className={`mode-option canvas-option ${suggestedMode === 'send_to_canvas' ? 'recommended' : ''}`}
              onClick={() => handleModeSelect('send_to_canvas')}
            >
              <div className="mode-icon">🎨</div>
              <div className="mode-info">
                <h4>发送到画布 {suggestedMode === 'send_to_canvas' && <span className="badge">推荐</span>}</h4>
                <p>将选中内容添加到知识画布</p>
                <p className="mode-hint">空间化整理、连接知识点</p>
              </div>
            </button>
          </div>
        </div>

        <div className="mode-dialog-footer">
          <button className="cancel-btn" onClick={onCancel}>取消</button>
        </div>
      </div>
    </div>
  );
};

export default ModeSelectionDialog;
